import { formatNumberMix } from '@/utils'
import moment from 'moment'
export default {
  data() { },
  methods: {
    setCardOptions(data = {}) {
      let that = this
      return [
        {
          title: this.$t('operate-analysis::day-report::成交额') + '(USD)',
          number: data && this.$dataCheck(formatNumberMix(data.grandTotalUsd, 2, ',')),
          dayRate: data && (Number(data.grandTotalUsdDay) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.grandTotalUsdDay, 2, '', '')),
          weekRate: data && (Number(data.grandTotalUsdWeek) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.grandTotalUsdWeek, 2, '', '')),
          dayValue: data && this.$dataCheck(formatNumberMix(data.grandTotalUsdDayValue, 2, '', '')),
          weekValue: data && this.$dataCheck(formatNumberMix(data.grandTotalUsdWeekValue, 2, '', '')),
          dayDt: data && data.dayDt,
          weekDt: data && data.weekDt,
          tooltip: this.$t('operate-analysis::day-report::成交额tooltip'),
          chartKey: 'grandTotalUsd'
        },
        {
          title: this.$t('operate-analysis::day-report::订单量'),
          number: data && this.$dataCheck(formatNumberMix(data.orderNum, 0, ',')),
          dayRate: data && (Number(data.orderNumDay) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.orderNumDay, 2, '', '')),
          weekRate: data && (Number(data.orderNumWeek) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.orderNumWeek, 2, '', '')),
          dayValue: data && this.$dataCheck(formatNumberMix(data.orderNumDayValue, 0, '', '')),
          weekValue: data && this.$dataCheck(formatNumberMix(data.orderNumWeekValue, 0, '', '')),
          dayDt: data && data.dayDt,
          weekDt: data && data.weekDt,
          tooltip: this.$t('operate-analysis::day-report::订单量tooltip'),
          chartKey: 'orderNum'
        },
        {
          title: this.$t('operate-analysis::day-report::客单价') + '(USD)',
          number: data && this.$dataCheck(formatNumberMix(data.customerPrice, 2, ',')),
          dayRate: data && (Number(data.customerPriceDay) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.customerPriceDay, 2, '', '')),
          weekRate: data && (Number(data.customerPriceWeek) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.customerPriceWeek, 2, '', '')),
          dayValue: data && this.$dataCheck(formatNumberMix(data.customerPriceDayValue, 2, '', '')),
          weekValue: data && this.$dataCheck(formatNumberMix(data.customerPriceWeekValue, 2, '', '')),
          dayDt: data && data.dayDt,
          weekDt: data && data.weekDt,
          tooltip: this.$t('operate-analysis::day-report::客单价tooltip'),
          chartKey: 'customerPrice'
        },
        {
          title: this.$t('operate-analysis::day-report::连带率'),
          number: data && this.$dataCheck(formatNumberMix(data.associatedPurchaseRate, 2, ',')),
          dayRate: data && (Number(data.associatedPurchaseRateDay) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.associatedPurchaseRateDay, 2, '', '')),
          weekRate: data && (Number(data.associatedPurchaseRateWeek) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.associatedPurchaseRateWeek, 2, '', '')),
          dayValue: data && this.$dataCheck(formatNumberMix(data.associatedPurchaseRateDayValue, 2, '', '')),
          weekValue: data && this.$dataCheck(formatNumberMix(data.associatedPurchaseRateWeekValue, 2, '', '')),
          dayDt: data && data.dayDt,
          weekDt: data && data.weekDt,
          tooltip: this.$t('operate-analysis::day-report::连带率tooltip'),
          chartKey: 'associatedPurchaseRate'
        },
        {
          title: this.$t('operate-analysis::day-report::营销花费') + '(USD)',
          number: data && this.$dataCheck(formatNumberMix(data.adTotalFee, 2, ',')),
          dayRate: data && (Number(data.adTotalFeeDay) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.adTotalFeeDay, 2, '', '')),
          weekRate: data && (Number(data.adTotalFeeWeek) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.adTotalFeeWeek, 2, '', '')),
          dayValue: data && this.$dataCheck(formatNumberMix(data.adTotalFeeDayValue, 2, '', '')),
          weekValue: data && this.$dataCheck(formatNumberMix(data.adTotalFeeWeekValue, 2, '', '')),
          dayDt: data && data.dayDt,
          weekDt: data && data.weekDt,
          tooltip: this.$t('operate-analysis::day-report::营销花费tooltip'),
          chartKey: 'adTotalFee'
        },
        {
          title: 'ROI',
          number: data && this.$dataCheck(formatNumberMix(data.roi, 2, ',')),
          dayRate: data && (Number(data.roiDay) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.roiDay, 2, '', '')),
          weekRate: data && (Number(data.roiWeek) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.roiWeek, 2, '', '')),
          dayValue: data && this.$dataCheck(formatNumberMix(data.roiDayValue, 2, '', '')),
          weekValue: data && this.$dataCheck(formatNumberMix(data.roiWeekValue, 2, '', '')),
          dayDt: data && data.dayDt,
          weekDt: data && data.weekDt,
          // tooltip: this.$t('operate-analysis::day-report::roitooltip'),
          contentCustomr: h => {
            return this.sourceType === 1 ? (<span>成交额÷营销花费，<a onClick={() => that.$router.push({ path: '/stores/shop-site', query: { type: this.$auth('stores::shop-site::fb-add') ? 2 : this.$auth('stores::shop-site::google-add') ? 3 : 2 } })}>绑定<br />
              广告账号</a>实时获取营销花费</span>) : (<span>成交额÷营销花费</span>)
          },
          chartKey: 'roi'
        },
        {
          title: this.$t('operate-analysis::day-report::预估毛利率'),
          number: data && this.$dataCheck(formatNumberMix(data.profitRate, 2, ',', '%')),
          dayRate: data && (Number(data.profitRateDay) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.profitRateDay, 2, '', '')),
          weekRate: data && (Number(data.profitRateWeek) > 0 ? '+' : '') + this.$dataCheck(formatNumberMix(data.profitRateWeek, 2, '', '')),
          dayValue: data && this.$dataCheck(formatNumberMix(data.profitRateDayValue, 2, '', '')),
          weekValue: data && this.$dataCheck(formatNumberMix(data.profitRateWeekValue, 2, '', '')),
          dayDt: data && data.dayDt,
          weekDt: data && data.weekDt,
          // tooltip: this.$t('operate-analysis::day-report::预估毛利率tooltip'),
          contentCustomr: h => {
            return this.sourceType === 1 ? (<span>（成交额-营销花费-商品成本-<br />
              其他预估成本）÷成交额，<a onClick={() => that.$router.push({ path: '/stores/shop-site', query: { type: this.$auth('stores::shop-site::fb-add') ? 2 : this.$auth('stores::shop-site::google-add') ? 3 : 2 } })}>绑定<br />
                广告账号</a>获取营销花费，<a onClick={() => that.$router.push('/products-info')}>导入商品<br />信息
              </a>获取商品成本，其他预估<br />成本可前往<a onClick={() => that.$router.push('/operate-config')}>经营配置</a>修改</span>)
              : (<span>（成交额-营销花费-商品成本-其他<br />预估成本）÷成交额，其他预估成本可前往<br /><a onClick={() => that.$router.push('/operate-config')}>经营配置</a>修改</span>)
          },
          chartKey: 'profitRate',
          unit: '%'
        },
      ]
    },
    // 分时监控
    setControlTimePriceData(data, ylist) {
      let max = 23
      // if (moment(this.params.dt).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
      //   max = Number(moment().format('HH'))
      // }
      let xAxis = []
      for (let i = 0; i <= max; i++) {
        xAxis.push(String(i))
      }
      return {
        type: 'line',
        // title: this.$t('operate-analysis::day-report::time_report'),
        title: '成交额分时监控',
        ref: 'lineChartPrice',
        height: '308px',
        chart: {
          grid: {
            top: '10%'
          },
          legend: {
            show: true,
            data: ylist
          },
          xAxis: {
            data: xAxis.map(item => item + ' h')
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('operate-analysis::day-report::成交额'),
              min: 0,

            }
          ],
          series: ylist.length ? ylist.map(item => {
            return {
              name: item,
              data: data.filter(el => item === el.payDate).map(el => el.grandTotalUsd),
              type: 'line'
            }
          }) : []
        }
      }
    },
    // 分时监控
    setControlTimeOrderData(data, ylist) {
      let max = 23
      // if (moment(this.params.dt).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
      //   max = Number(moment().format('HH'))
      // }
      let xAxis = []
      for (let i = 0; i <= max; i++) {
        xAxis.push(String(i))
      }
      return {
        type: 'line',
        // title: this.$t('operate-analysis::day-report::time_report'),
        title: '订单量分时监控',
        ref: 'lineChartOrder',
        tooltip: '指标在不同日期中每小时的趋势',
        height: '308px',

        chart: {
          grid: {
            top: '10%'
          },
          legend: {
            show: true,
            data: ylist
          },
          xAxis: {
            data: xAxis.map(item => item + ' h')
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('operate-analysis::day-report::订单量'),
              min: 0
            }
          ],
          series: ylist.length ? ylist.map(item => {
            return {
              name: item,
              data: data.filter(el => item === el.payDate).map(el => el.orderNum),
              type: 'line'
            }
          }) : []
        }
      }
    },
    setSalesTopConfig(data = []) {
      let sort = [...data]
      sort.sort((a, b) => {
        return Number(b.grandTotalUsd) - Number(a.grandTotalUsd)
      })
      let max = sort.length ? Number(sort[0].grandTotalUsd) : 1
      return {
        title: this.$t('operate-analysis::day-report::店铺TopTitle'),
        data: data.map(el => ({
          name: el.brandName,
          num: el.grandTotalUsd,
          per: (Number(el.grandTotalUsd) / max) * 100
        }))
      }
    },
    setSpuSalesTopConfig(data = []) {
      let sort = [...data]
      sort.sort((a, b) => {
        return Number(b.qty) - Number(a.qty)
      })
      let max = sort.length ? Number(sort[0].qty) : 1
      return {
        title: this.$t('operate-analysis::day-report::spuTopTitle'),
        data: data.map(el => ({
          name: el.spuId,
          num: el.qty,
          per: (Number(el.qty) / max) * 100
        }))
      }
    },
    setOptimizerTopConfig(data = []) {
      let sort = [...data]
      sort.sort((a, b) => {
        return Number(b.grandTotalUsd) - Number(a.grandTotalUsd)
      })
      let max = sort.length ? Number(sort[0].grandTotalUsd) : 1
      return {
        title: this.$t('operate-analysis::day-report::优化师TopTitle'),
        // tooltip: this.$t('operate-analysis::day-report::优化师TopTooltip'),
        tooltipCustomr: h => (<span>根据订单中utm广告参数，解析出<br />归属优化师，将订单金额视为该<br />优化师成交额；<a onClick={() => this.$router.push({ path: '/stores/shop-site', query: { type: 6 } })}>配置优化师</a>标识即可<br />解析优化师</span>),
        data: data.map(el => ({
          name: el.adOptimizerNameZh,
          num: el.grandTotalUsd,
          per: (Number(el.grandTotalUsd) / max) * 100
        }))
      }
    },
    setShopTableConfig(columnMetas, data = [], reportId, offset, config, last) {
      let columns = columnMetas.map(el => el.chinese)
      // 确保表头是最新的
      this.shopColumns = this.shopColumns.filter(el => columns.some(item => el.prop === item))
      // 如有新增列则默认勾选表头
      columns.forEach(el => {
        if (this.shopColumns.every(item => !item.prop || item.prop !== el)) {
          this.shopColumns.push({ prop: el, label: el, active: true })
        }
      })
      return {
        type: 'table',
        offsetLoading: false,
        offset: offset || 1,
        last: last || false,
        title: this.$t('operate-analysis::day-report::店铺TableTitle'),
        ref: 'shopSale',
        height: '372px',
        btns: [
          { icon: 'icona-03shezhi', tip: '表头设置', call: 'setting', tableName: 'shop' },
          { icon: 'iconicon_Import', tip: this.$t('system::function::download'), call: 'download', loading: false, reportId, target: 'shopTableConfig', title: this.$t('operate-analysis::day-report::店铺TableTitle') + moment(this.params.dt).format('YYYY-MM-DD') },
          { icon: 'iconCopy-Solid', tip: this.$t('system::common::btn::copy'), call: 'copy', link: '/edit-report?isPlatformBoard=1&folderID=1&boardID=1&reportID=13062&limitSize=200&back=day-report&jump=true&isPerson=true' },
        ],
        cancelShadow: true,
        columns: this.shopColumns.length ? this.shopColumns.filter(item => item.active).map(el => el.prop) : columns,
        showColumns: this.shopColumns,
        tableData: config && config.tableData ? config.tableData.concat(data) : data,
        sort: config.sort || null,
        headerTooltip: {
          '店铺名称': this.$t('operate-analysis::day-report::店铺名称-tableTooltip'),
          '成交额': this.$t('operate-analysis::day-report::成交额-tableTooltip'),
          '成交额环比': this.$t('operate-analysis::day-report::成交额环比-tableTooltip'),
          '成交额占比': this.$t('operate-analysis::day-report::成交额占比-tableTooltip'),
          '营销费用': this.$t('operate-analysis::day-report::营销费用-tableTooltip'),
          'ROI': this.$t('operate-analysis::day-report::ROI-tableTooltip'),
          '订单量': this.$t('operate-analysis::day-report::订单量-tableTooltip'),
          '客单价': this.$t('operate-analysis::day-report::客单价-tableTooltip'),
          'CPA': this.$t('operate-analysis::day-report::CPA-tableTooltip'),
          '连带率': this.$t('operate-analysis::day-report::连带率-tableTooltip'),
          '转化率': this.$t('operate-analysis::day-report::转化率-tableTooltip'),
          '预估毛利润': this.$t('operate-analysis::day-report::预估毛利润-tableTooltip'),
          '预估毛利率': this.$t('operate-analysis::day-report::预估毛利率-tableTooltip'),
        }
      }
    },
    setSpuTableConfig(columnMetas, data = [], reportId, offset, config, last) {
      let columns = columnMetas.map(el => el.chinese)
      // 确保表头是最新的
      this.spuColumns = this.spuColumns.filter(el => columns.some(item => el.prop === item))
      // 如有新增列则默认勾选表头
      columns.forEach(el => {
        if (this.spuColumns.every(item => !item.prop || item.prop !== el)) {
          this.spuColumns.push({ prop: el, label: el, active: true })
        }
      })
      return {
        type: 'table',
        offsetLoading: false,
        offset: offset || 1,
        last: last || false,
        title: this.$t('operate-analysis::day-report::spuTableTitle'),
        ref: 'spuSale',
        height: '372px',
        btns: [
          { icon: 'icona-03shezhi', tip: '表头设置', call: 'setting', tableName: 'spu' },
          { icon: 'iconicon_Import', tip: this.$t('system::function::download'), call: 'download', loading: false, reportId, target: 'spuTableConfig', title: this.$t('operate-analysis::day-report::spuTableTitle') + moment(this.params.dt).format('YYYY-MM-DD') },
          { icon: 'iconCopy-Solid', tip: this.$t('system::common::btn::copy'), call: 'copy', link: '/edit-report?isPlatformBoard=1&folderID=1&boardID=1&reportID=13064&limitSize=200&back=day-report&jump=true&isPerson=true' },
        ],
        cancelShadow: true,
        columns: this.spuColumns.length ? this.spuColumns.filter(item => item.active).map(el => el.prop) : columns,
        showColumns: this.spuColumns,
        tableData: config && config.tableData ? config.tableData.concat(data) : data,
        sort: config.sort || null,
        headerTooltip: {
          '平台SPU_ID': this.$t('operate-analysis::day-report::平台SPU_ID-spuTableTooltip'),
          '销量': this.$t('operate-analysis::day-report::销量-spuTableTooltip'),
          '销量环比': this.$t('operate-analysis::day-report::销量环比-spuTableTooltip'),
          '成交额': this.$t('operate-analysis::day-report::成交额-spuTableTooltip'),
          '成交额环比': this.$t('operate-analysis::day-report::成交额环比-spuTableTooltip'),
          '成交额占比': this.$t('operate-analysis::day-report::成交额占比-spuTableTooltip'),
        }
      }
    },
    setOptimizerTableConfig(columnMetas, data = [], reportId, offset, config, last) {
      let columns = columnMetas.map(el => el.chinese)
      // 确保表头是最新的
      this.optimizerColumns = this.optimizerColumns.filter(el => columns.some(item => el.prop === item))
      // 如有新增列则默认勾选表头
      columns.forEach(el => {
        if (this.optimizerColumns.every(item => !item.prop || item.prop !== el)) {
          this.optimizerColumns.push({ prop: el, label: el, active: true })
        }
      })
      return {
        type: 'table',
        offsetLoading: false,
        offset: offset || 1,
        last: last || false,
        title: this.$t('operate-analysis::day-report::优化师TableTitle'),
        tooltipCustomr: h => (<span>根据订单中utm广告参数，解析出<br />归属优化师，将订单金额视为该<br />优化师成交额；<a onClick={() => this.$router.push({ path: '/stores/shop-site', query: { type: 6 } })}>配置优化师</a>标识即可<br />解析优化师</span>),
        ref: 'optimizerSale',
        height: '372px',
        btns: [
          { icon: 'icona-03shezhi', tip: '表头设置', call: 'setting', tableName: 'optimizer' },
          { icon: 'iconicon_Import', tip: this.$t('system::function::download'), call: 'download', loading: false, reportId, target: 'optimizerTableConfig', title: this.$t('operate-analysis::day-report::优化师TableTitle') + moment(this.params.dt).format('YYYY-MM-DD') },
          { icon: 'iconCopy-Solid', tip: this.$t('system::common::btn::copy'), call: 'copy', link: '/edit-report?isPlatformBoard=1&folderID=1&boardID=1&reportID=13063&limitSize=200&back=day-report&jump=true&isPerson=true' },
        ],
        cancelShadow: true,
        columns: this.optimizerColumns.length ? this.optimizerColumns.filter(item => item.active).map(el => el.prop) : columns,
        showColumns: this.optimizerColumns,
        tableData: config && config.tableData ? config.tableData.concat(data) : data,
        sort: config.sort || null,
        headerTooltip: {
          '优化师姓名': this.$t('operate-analysis::day-report::优化师姓名-OptimizerTableTooltip'),
          '一级部门': this.$t('operate-analysis::day-report::一级部门-OptimizerTableTooltip'),
          '成交额': this.$t('operate-analysis::day-report::成交额-OptimizerTableTooltip'),
          '成交额环比': this.$t('operate-analysis::day-report::成交额环比-OptimizerTableTooltip'),
          '成交额占比': this.$t('operate-analysis::day-report::成交额占比-OptimizerTableTooltip'),
          '营销费用': this.$t('operate-analysis::day-report::营销花费-OptimizerTableTooltip'),
          'ROI': this.$t('operate-analysis::day-report::ROI-OptimizerTableTooltip'),
          '月目标': this.$t('operate-analysis::day-report::月目标-OptimizerTableTooltip'),
          '月目标达成进度': this.$t('operate-analysis::day-report::月目标达成进度-OptimizerTableTooltip'),
        }
      }
    },

  }
}
